module.exports = __webpack_public_path__ + "img/refreshBasicInfo.54b01545.svg";